class scrollHelper{
	constructor() {
		this.body = document.querySelector('body');
		this.scrollableElements = [window, this.body.classList.contains('single-book-page') ? document.querySelector('.page-wrapper') : null].filter(elem => elem);
	}
	to(el, tar, buff) {
		$(el).click(function (e) {
			e.preventDefault();
			var target = typeof tar === 'undefined' ? $(this).attr('href') : tar,
				buffer = typeof buff === 'undefined' ? parseInt($('body').css('margin-top')) : buff,
				scrollDest = parseInt($(target).offset().top - buffer);
			$('html, body').animate({
				scrollTop: scrollDest,
			}, 1000);
		});
	}
	top(el) {
		window.app.util.multiEventBind(el, 'click touchstart', e => {
			$('html, body, .page-wrapper').animate({
				scrollTop: 0
			}, 1000);
		});
	}
	toggleClassOnScroll(el) {
		//let hasRequestedWork = false;
		let threshold = el.getAttribute('data-scroll-threshold');
		let upClass = el.getAttribute('data-up-class');
		let target = document.querySelector(el.getAttribute('data-target')) || el;
		this.scrollableElements.forEach(scrollableElement => {
			this.debouncedScrollHandle(scrollableElement, () => {
				target.classList.toggle(upClass, scrollableElement.scrollY || scrollableElement.scrollTop > threshold);
			});
		});
		this.progress(el);
	}
	progress(el) {
		/*this.scrollableElements.forEach(scrollableElement => {
			this.debouncedScrollHandle(scrollableElement, () => {
				let scrollPos = (scrollableElement.scrollY || scrollableElement.scrollTop);
				if (scrollPos !== undefined) {
					scrollPos += window.innerHeight;
					const scrollableAmount = (this.body.classList.contains('single-book-page') ? document.querySelector('.page-wrapper') : document.documentElement).offsetHeight;
					const percentage = (scrollPos / scrollableAmount) * 100;
					console.log(`${percentage}%`);
				}
			});
		})*/
	}
	debouncedScrollHandle(element, callback) {
		let hasRequestedWork = false;
		element.addEventListener('scroll', () => {
			if (!hasRequestedWork) {
				window.requestAnimationFrame(() => {
					callback();
					hasRequestedWork = false;
				});
				hasRequestedWork = true;
			}
		});
	}
}
window.app.add('scroll', new scrollHelper());